import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { AccountProfileComponent } from '@qaroni-app/account/components/account-profile/account-profile.component';
import { AccountService } from '@qaroni-app/account/services/account.service';
import { Account } from '@qaroni-app/account/types/account';

@Component({
  selector: 'qaroni-dialog-account',
  standalone: true,
  imports: [AccountProfileComponent],
  templateUrl: './dialog-account.component.html',
  styleUrl: './dialog-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAccountComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  public dialogRef = inject(MatDialogRef<DialogAccountComponent>);
  public readonly data = inject<Account | null>(MAT_DIALOG_DATA);
  private accountService = inject(AccountService);

  public account$ = this.accountService.account$;
  public accountMessage$ = this.accountService.getMessage$();

  ngOnInit(): void {
    this.subs.add(this.account$.subscribe(this.getAccount));
    this.subs.add(this.accountMessage$.subscribe(this.getMessage));
  }

  private getMessage = (message: string): void => {
    if (!message) {
      return;
    }

    if (message.includes('Reset password')) {
      this.close();
    }
  };

  private getAccount = (account: Account | null): void => {
    if (!account) {
      return;
    }

    this.close();
  };

  public close(): void {
    this.dialogRef.close(false);
  }
}
